export default "__VITE_ASSET__jmhTdYBH__"